export default __webpack_public_path__ + "static/media/profile.b0831213.svg";